import React, { useEffect } from "react";
import ProviderDTO from "../../shared/dtos/providerDTO";
import { markerCarBusyIcon, marketIcon } from "../../shared/constants/Images";
import { Button, Col, Rate } from "antd";
import { Marker, InfoWindow } from "@react-google-maps/api";
import { LoadingOutlined } from "@ant-design/icons";

interface MapProps {
  providers: Array<ProviderDTO>;
  assignProvider?: (provider: ProviderDTO) => void;
  setProvider?: (provider: ProviderDTO | null) => void;
  selectedProvider?: ProviderDTO | null;
  map?: google.maps.Map | null;
}

export const ProviderMarkers: React.FunctionComponent<MapProps> = (props) => {
  const { providers, assignProvider, selectedProvider, setProvider, map } =
    props;

  useEffect(() => {
    if (
      map &&
      selectedProvider &&
      selectedProvider.latitude &&
      selectedProvider.longitude
    ) {
      map.setCenter({
        lat: selectedProvider.latitude,
        lng: selectedProvider.longitude,
      });
    }
  }, [map, selectedProvider]);

  return (
    <>
      {providers
        ?.filter((x) => x.longitude && x.latitude)
        .map((provider, index) => {
          return (
            <Marker
              key={index}
              position={{
                lat: provider?.latitude!,
                lng: provider?.longitude!,
              }}
              title={`${provider.firstName} ${provider.lastName}`}
              icon={provider?.onTrip ? markerCarBusyIcon : marketIcon}
              onClick={() => {
                setProvider && setProvider(provider);
              }}
            />
          );
        })}
      {selectedProvider &&
        selectedProvider.latitude &&
        selectedProvider.longitude && (
          <InfoWindow
            position={{
              lat: selectedProvider.latitude,
              lng: selectedProvider.longitude,
            }}
            onCloseClick={() => {
              setProvider && setProvider(null);
            }}
          >
            <Col style={{ color: "black" }}>
              {!selectedProvider.id && (
                <Col
                  span={24}
                  style={{
                    fontSize: 40,
                    overflow: "hidden",
                  }}
                >
                  <LoadingOutlined />
                </Col>
              )}
              {selectedProvider.id && (
                <>
                  <h2>
                    Nombre: {selectedProvider.firstName ?? ""}{" "}
                    {selectedProvider.lastName ?? ""}
                  </h2>
                  <h3>
                    Ranking:{" "}
                    {<Rate disabled={true} value={selectedProvider.rating} />}
                  </h3>
                  <h3>Teléfono: {selectedProvider.mobile}</h3>
                  {!!selectedProvider.services?.length && (
                    <h3>
                      Tipos de servicio:{" "}
                      {selectedProvider.services
                        ?.map((x) => x.serviceType?.name)
                        .join(", ")}
                    </h3>
                  )}
                  <h3>
                    Modelo de carro:{" "}
                    {selectedProvider?.services
                      ? selectedProvider?.services[0].serviceModel
                      : "Autos"}
                  </h3>
                  {assignProvider && (
                    <Button
                      type="primary"
                      onClick={() => assignProvider(selectedProvider)}
                    >
                      Asignar este proveedor
                    </Button>
                  )}
                </>
              )}
            </Col>
          </InfoWindow>
        )}
    </>
  );
};
